module.exports = "/images/header-logo@3x.png?6546feaddd9ef5a06415f2b14c98c971";